import * as React from 'react';
import StarIcon from '../../images/dynamicIcons/starIcon';

interface ScoreSelectorProps {
    selectedScore: number,
    score_onClick?: (index: number) => void;
    isView?: boolean;
}

interface ScoreSelectorState {
    hoveredIndex: number
}

export default class ScoreSelector extends React.PureComponent<ScoreSelectorProps, ScoreSelectorState> {
    constructor(props: ScoreSelectorProps) {
        super(props);

        this.state = { hoveredIndex: -1 }
    }

    public render() {

        return (
            <div className='score__wrapper'>

                {[1, 2, 3, 4, 5].map((element) =>
                    <div className={`score 
                    ${this.state.hoveredIndex >= element && !this.props.isView && "hovered"}
                    ${this.props.selectedScore >= element && "selected"}`}
                        onMouseOver={() => this.setState({ hoveredIndex: element })}
                        onMouseLeave={() => this.setState({ hoveredIndex: -1 })}
                        onClick={() => this.props.score_onClick && this.props.score_onClick(element)}
                        key={element}
                    ><StarIcon /></div>
                )}
            </div>
        );
    }
}